// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".application-form .el-card__body[data-v-4a12300a]{padding:1rem 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
